import type { ParamDef } from './types'
import type { ParamValue } from './types'

/**
 * Spec 041: params recorded on an old run or session may name a parameter the
 * strategy no longer has (`ema_cross` lost `instrument` and `bars`). Keep what
 * still exists, report what was dropped.
 */
export function paramsForConfig(
  recorded: Record<string, ParamValue>,
  defs: ParamDef[],
): { kept: Record<string, ParamValue>; dropped: string[] } {
  const known = new Set(defs.map((d) => d.name))
  const kept: Record<string, ParamValue> = {}
  const dropped: string[] = []
  for (const [name, value] of Object.entries(recorded)) {
    if (known.has(name)) kept[name] = value
    else dropped.push(name)
  }
  dropped.sort()
  return { kept, dropped }
}

export function droppedNote(dropped: string[]): string | null {
  if (dropped.length === 0) return null
  if (dropped.length === 1) return `1 param no longer exists and was dropped: ${dropped[0]}.`
  return `${dropped.length} params no longer exist and were dropped: ${dropped.join(', ')}.`
}
